import React, { memo, useCallback, useState } from 'react';
import { Button } from 'components/ui/button';
import { Checkbox } from 'components/ui/checkbox';
import { Paper } from '@app/components';
import { DocTypeName, DocTypes } from '@app/models';

interface Props {
  onSubmit: (type: DocTypes) => void;
}

function TenderCategoryForm(props: Props) {
  const { onSubmit } = props;
  const [docType, setDocType] = useState<DocTypes>(DocTypes.ACT);

  const onChange = useCallback(
    (type: DocTypes) => (checked: boolean) => {
      if (!checked) {
        return;
      }
      setDocType(type);
    },
    []
  );

  const onClickNext = useCallback(
    (e: React.FormEvent<HTMLButtonElement>) => {
      e.preventDefault();
      e.stopPropagation();
      onSubmit(docType);
    },
    [docType, onSubmit]
  );

  return (
    <div className="bg-card rounded-lg p-6 shadow w-full max-w-lg mx-auto">
      <h2 className="text-lg font-semibold mb-4">Выберите тип документа</h2>
      <div className="flex flex-col gap-2 mb-6">
        <div className="flex items-center gap-2">
          <Checkbox
            id="act"
            checked={DocTypes.ACT === docType}
            onCheckedChange={onChange(DocTypes.ACT)}
          />
          <label htmlFor="act" className="text-sm cursor-pointer">
            {DocTypeName[DocTypes.ACT]}
          </label>
        </div>
        <div className="flex items-center gap-2">
          <Checkbox
            id="invoice"
            checked={DocTypes.INVOICE === docType}
            onCheckedChange={onChange(DocTypes.INVOICE)}
          />
          <label htmlFor="invoice" className="text-sm cursor-pointer">
            {DocTypeName[DocTypes.INVOICE]}
          </label>
        </div>
        <div className="flex items-center gap-2">
          <Checkbox
            id="additional"
            checked={DocTypes.ADDITIONAL_AGREEMENT === docType}
            onCheckedChange={onChange(DocTypes.ADDITIONAL_AGREEMENT)}
          />
          <label htmlFor="additional" className="text-sm cursor-pointer">
            {DocTypeName[DocTypes.ADDITIONAL_AGREEMENT]}
          </label>
        </div>
        <div className="flex items-center gap-2">
          <Checkbox
            id="other"
            checked={DocTypes.OTHER === docType}
            onCheckedChange={onChange(DocTypes.OTHER)}
          />
          <label htmlFor="other" className="text-sm cursor-pointer">
            {DocTypeName[DocTypes.OTHER]}
          </label>
        </div>
      </div>
      <div className="flex justify-end">
        <Button onClick={onClickNext}>Продолжить</Button>
      </div>
    </div>
  );
}

export default memo(TenderCategoryForm);
